import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ColorPicker } from 'primereact/colorpicker';
import { toast } from 'react-toastify';
import { fetchCroppedImage } from '@/utils/constants';
import { priorityicon1, priorityicon10, priorityicon11, priorityicon12, priorityicon13, priorityicon14, priorityicon15, priorityicon16, priorityicon17, priorityicon2, priorityicon3, priorityicon4, priorityicon5, priorityicon6, priorityicon7, priorityicon8, priorityicon9, priorityimg1, priorityimg2, priorityimg3 } from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

const ServiceEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [activeTab, setActiveTab] = useState(0);
  const [secondActiveTab, setSecondActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [showCropModalTwo, setShowCropModalTwo] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [imageImagesOne, setImageImagesOne] = useState<string[]>([]);
  const [iconImagesTwo, setIconImagesTwo] = useState<string[]>([]);
  const icons = [
    priorityimg1,
    priorityimg2,
    priorityimg3,
    priorityimg1,
    priorityimg2,
    priorityimg3,
    priorityimg1,
    priorityimg2,
    priorityimg3,
  ];
  const countIcons = [
    priorityicon1,
    priorityicon2,
    priorityicon3,
    priorityicon4,
    priorityicon5,
    priorityicon6,
    priorityicon7,
    priorityicon8,
    priorityicon9,
    priorityicon10,
    priorityicon11,
    priorityicon12,
    priorityicon13,
    priorityicon14,
    priorityicon15,
    priorityicon16,
    priorityicon17,
  ];
  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150")
    // setCropImageWidth("150")
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const updateImageSectionTwo = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("50")
    // setCropImageWidth("50")
    // setSelectedCropImage(image);
    // setShowCropModalTwo(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImageTwo(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };

  const handleCroppedImageTwo = async (image: any) => {
    setShowCropModalTwo(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      counthandleImageChange(imageLink, secondActiveTab);
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_3.home.section_9.card_section.collection,
    ];

    let newCard = {
      icon: 'assets/home/priorityimg1.jpg',
      collection_title: '',
      collection_paragraph: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_3.home.section_9.card_section.collection,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_3.home.section_9.card_section.collection,
    ];
    if (index != undefined) {
      updatedCollection = [
        ...editData.theme_3.home.section_9.card_section.collection,
      ];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            [name]: value,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_3.home.section_9.card_section.collection,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      icon: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };

  const countAddCollection = () => {
    let updatedCount: any = [
      ...editData.theme_3.home.section_9.card_section.count_section,
    ];

    let newCard = {
      icon: 'assets/icons/priorityicon1.png',
      text: '',
      count: '',
    };
    updatedCount.splice(secondActiveTab + 1, 0, newCard);
    setSecondActiveTab(secondActiveTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              count_section: updatedCount,
            },
          },
        },
      },
    }));
  };
  const countRemoveCollection = (index: any) => {
    let updatedCount: any = [
      ...editData.theme_3.home.section_9.card_section.count_section,
    ];
    updatedCount.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              count_section: updatedCount,
            },
          },
        },
      },
    }));
  };

  const counthandleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCount: any = [
      ...editData.theme_3.home.section_9.card_section.count_section,
    ];
    if (index != undefined) {
      updatedCount = [
        ...editData.theme_3.home.section_9.card_section.count_section,
      ];
      updatedCount[index] = {
        ...updatedCount[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9.card_section,
            [name]: value,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              count_section: updatedCount,
            },
          },
        },
      },
    }));
  };

  const counthandleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_3.home.section_9.card_section.count_section,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      icon: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_9: {
            ...prevJsonData.theme_3.home.section_9,
            card_section: {
              ...prevJsonData.theme_3.home.section_9.card_section,
              count_section: updatedCollection,
            },
          },
        },
      },
    }));
  };
  // Auto-generate prompt based on current card context for Card Section 1
  const generateAutoPromptImageOne = (): string => {
    // Get context from the current active card
    const currentCard = editData?.theme_3?.home?.section_9?.card_section?.collection?.[activeTab];
    const cardTitle = currentCard?.collection_title || '';
    const cardParagraph = currentCard?.collection_paragraph || '';
    const sectionTitle = editData?.theme_3?.home?.section_9?.title || '';
    const sectionParagraph = editData?.theme_3?.home?.section_9?.paragraph || '';
    
    // Build context-based prompt for image
    let contextPrompt = 'modern professional image for service card';
    
    if (cardTitle || cardParagraph || sectionTitle || sectionParagraph) {
      const contextParts: string[] = [];
      if (cardParagraph) {
        // Extract keywords from paragraph
        const keywords = cardParagraph.split(' ').slice(0, 3).join(' ');
      } else if (sectionParagraph) {
        const keywords = sectionParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add image-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for service card, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI image save for Card Section 1
  const handleAIImageSaveOne = (imageUrl: string) => {
    // Auto-apply the image to the current active card
    handleImageChange(imageUrl, activeTab);
    
    // Add to images array for slider
    setImageImagesOne(prevImages => [...prevImages, imageUrl]);
    
    // Update Redux store with the new image in image array
    const templateKey = template ? `template${template}` : 'template3';
    const currentTemplate = templateImages[templateKey] || {};
    const currentImages = currentTemplate.image || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        image: [...currentImages, { url: imageUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  // Auto-generate prompt based on current card context for Card Section 2
  const generateAutoPromptIconTwo = (): string => {
    // Get context from the current active card in count_section
    const currentCard = editData?.theme_3?.home?.section_9?.card_section?.count_section?.[secondActiveTab];
    const cardText = currentCard?.text || '';
    const cardCount = currentCard?.count || '';
    const sectionTitle = editData?.theme_3?.home?.section_9?.title || '';
    const sectionParagraph = editData?.theme_3?.home?.section_9?.paragraph || '';
    
    // Build context-based prompt for icon
    let contextPrompt = 'modern minimalist icon design';
    
    if (cardText || cardCount || sectionTitle || sectionParagraph) {
      const contextParts: string[] = [];
      if (sectionParagraph) {
        const keywords = sectionParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add icon-specific styling
    contextPrompt += ', clean modern minimalist icon, professional design, suitable for card icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save for Card Section 2
  const handleAIIconSaveTwo = (iconUrl: string) => {
    // Auto-apply the icon to the current active card in count_section
    counthandleImageChange(iconUrl, secondActiveTab);
    
    // Add to icons array for slider
    setIconImagesTwo(prevIcons => [...prevIcons, iconUrl]);
    
    // Update Redux store with the new icon in icon array
    const templateKey = template ? `template${template}` : 'template3';
    const currentTemplate = templateImages[templateKey] || {};
    const currentIcons = currentTemplate.icon || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        icon: [...currentIcons, { url: iconUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template3';
      const currentTemplate = templateImages[templateKey];
      
      // Load images for Card Section 1
      const imageImgs = currentTemplate?.image || [];
      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              resolve({ url, width: img.width, height: img.height });
            };
            img.onerror = () => {
              resolve(null);
            };
            img.src = url;
          });
        };

        const filterImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setImageImagesOne(squareImages);
        };

        filterImages();
      } else {
        setImageImagesOne([]);
      }

      // Load icons for Card Section 2
      const iconImgs = currentTemplate?.icon || [];
      if (Array.isArray(iconImgs) && iconImgs.length > 0) {
        const loadIconDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              resolve({ url, width: img.width, height: img.height });
            };
            img.onerror = () => {
              resolve(null);
            };
            img.src = url;
          });
        };

        const filterIcons = async () => {
          const iconPromises = iconImgs.map((img: any) => loadIconDimensions(img.url));
          const loadedIcons = await Promise.all(iconPromises);
          
          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareIcons = loadedIcons
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setIconImagesTwo(squareIcons);
        };

        filterIcons();
      } else {
        setIconImagesTwo([]);
      }
    } else {
      setImageImagesOne([]);
      setIconImagesTwo([]);
    }
  }, [templateImages, template]);

  return (
    <>
      {' '}
      <>
        <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Section9 Theme Edit</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-content modal-body">
              <div className="edit-section">
                {/* <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="sub_heading_top"
                        value={editData?.theme_3?.home?.section_9?.sub_heading_top}
                        onChange={handleChange}
                        maxLength={250}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
                <div className="row">
                  <div className="col">
                    <div className="mb-3">
                      <label className="form-label">
                        Title<small>(max 250 char)</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={editData?.theme_3?.home?.section_9?.title}
                        onChange={handleChange}
                        maxLength={250}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">
                          Description
                        </label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({
                              target: {
                                name: 'paragraph',
                                value: content,
                              },
                            });
                          }}
                          contentType="product_description"
                          placeholder="Describe your services. Example: 'Write about our service offerings'"
                          context="This is for the main service section description with 2 liner or 20 words"
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="paragraph"
                        value={editData?.theme_3?.home?.section_9?.paragraph}
                        onChange={handleChange}
                        maxLength={1200}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">header 1 Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="h2color"
                          value={editData?.theme_3?.home?.section_9?.h2color}
                        />
                        <ColorPicker
                          name="h2color"
                          format="hex"
                          onChange={handleChange}
                          value={editData?.theme_3?.home?.section_9?.h2color}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">header 2 Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="h3color"
                          value={editData?.theme_3?.home?.section_9?.h3color}
                        />
                        <ColorPicker
                          name="h3color"
                          format="hex"
                          onChange={handleChange}
                          value={editData?.theme_3?.home?.section_9?.h3color}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="mb-3">
                      <label className="form-label">paragraph Color</label>
                      <div className="input-group color-change">
                        <input
                          type="text"
                          className="form-control"
                          name="paracolor"
                          value={editData?.theme_3?.home?.section_9?.paracolor}
                        />
                        <ColorPicker
                          name="paracolor"
                          format="hex"
                          onChange={handleChange}
                          value={editData?.theme_3?.home?.section_9?.paracolor}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="modal-title">Card Section 1</h5>
              <div className="edit-section">
                <ul className="nav nav-tabs">
                  <Swiper
                    spaceBetween={15}
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1024: {
                        slidesPerView: 3,
                      },
                    }}
                    className="homejson-slider"
                  >
                    {editData?.theme_3?.home?.section_9?.card_section?.collection?.map(
                      (card: any, index: any) => (
                        <SwiperSlide key={index}>
                          <li key={index} className="nav-item nav-option">
                            <a
                              className={`nav-link ${
                                activeTab === index ? 'active' : ''
                              }`}
                              onClick={() => setActiveTab(index)}
                            >
                              Card Section {index + 1}
                            </a>
                            <a
                              className="tab-close"
                              onClick={() => {
                                removeCollection(index);
                              }}
                            >
                              <i
                                className="fas fa-times"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        </SwiperSlide>
                      )
                    )}
                  </Swiper>
                </ul>
                <div className="tab-content">
                  {editData?.theme_3?.home?.section_9?.card_section?.collection?.map(
                    (card: any, index: any) => (
                      <div
                        key={index}
                        className={`tab-pane fade ${
                          activeTab === index ? 'show active' : ''
                        }`}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="img-bg active">
                              <img
                                src={card.icon}
                                alt={`Card Icon ${index + 1}`}
                              />
                            </div>
                            <div className="img-options w-100">
                              {imageImagesOne.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: {
                                      slidesPerView: 1,
                                    },
                                    768: {
                                      slidesPerView: 4,
                                    },
                                    1024: {
                                      slidesPerView: 6,
                                    },
                                  }}
                                  className="homejson-slider"
                                >
                                  {imageImagesOne.map((imageUrl: string, imgIndex: number) => (
                                    <SwiperSlide key={imgIndex}>
                                      <div
                                        className="img-option"
                                        onClick={() =>
                                          handleImageChange(imageUrl, index)
                                        }
                                      >
                                        <img
                                          src={imageUrl}
                                          alt="AI Image"
                                          className="img-fluid"
                                        />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Images Available</h6>
                                    <p className="text-muted small mb-3">
                                      Generate AI images or upload your own to see them here
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* AI Image Generator */}
                        <AIImageGenerator
                          generateAutoPrompt={generateAutoPromptImageOne}
                          onSave={handleAIImageSaveOne}
                          imageType="image"
                          defaultWidth="1024"
                          defaultHeight="1024"
                          title="AI Image"
                          autoGenerate={true}
                          template={template}
                        />

                        <div className="mb-3">
                          <label className="form-label">Upload Image</label>
                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            className="form-control"
                            name="image"
                            onChange={updateImageSectionOne}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">
                            Title<small>(max 250 char)</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="collection_title"
                            value={card.collection_title}
                            onChange={(e) => handleChange(e, index)}
                            maxLength={250}
                          />
                        </div>
                        <div className="mb-3">
                          <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                            <label className="form-label mb-0 mr-2">
                              Description
                            </label>
                            <AIContentWriter
                              onContentGenerated={(content) => {
                                handleChange({
                                  target: {
                                    name: 'collection_paragraph',
                                    value: content,
                                  },
                                }, index);
                              }}
                              contentType="product_description"
                              placeholder="Describe this service. Example: 'Write about our cleaning service quality'"
                              context="This is for a service card description with 2 liner or 20 words"
                            />
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            name="collection_paragraph"
                            value={card.collection_paragraph}
                            onChange={(e) => handleChange(e, index)}
                            maxLength={1200}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="add-section">
                <div className="row">
                  <div
                    onClick={() => {
                      addCollection();
                    }}
                    className="col text-center"
                  >
                    Add Card<i className="fas fa-plus-square ms-2"></i>
                  </div>
                </div>
              </div>
              <h5 className="modal-title">Card Section 2</h5>
              <div className="edit-section">
                <ul className="nav nav-tabs">
                  <Swiper
                    spaceBetween={15}
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1024: {
                        slidesPerView: 3,
                      },
                    }}
                    className="homejson-slider"
                  >
                    {editData?.theme_3?.home?.section_9?.card_section?.count_section?.map(
                      (card: any, index: any) => (
                        <SwiperSlide key={index}>
                          <li key={index} className="nav-item nav-option">
                            <a
                              className={`nav-link ${
                                secondActiveTab === index ? 'active' : ''
                              }`}
                              onClick={() => setSecondActiveTab(index)}
                            >
                              Card Section {index + 1}
                            </a>
                            <a
                              className="tab-close"
                              onClick={() => {
                                countRemoveCollection(index);
                              }}
                            >
                              <i
                                className="fas fa-times"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        </SwiperSlide>
                      )
                    )}
                  </Swiper>
                </ul>
                <div className="tab-content">
                  {editData?.theme_3?.home?.section_9?.card_section?.count_section?.map(
                    (card: any, index: any) => (
                      <div
                        key={index}
                        className={`tab-pane fade ${
                          secondActiveTab === index ? 'show active' : ''
                        }`}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="img-bg active">
                              <img
                                src={card.icon}
                                alt={`Card Icon ${index + 1}`}
                              />
                            </div>
                            <div className="img-options w-100">
                              {iconImagesTwo.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: {
                                      slidesPerView: 1,
                                    },
                                    768: {
                                      slidesPerView: 4,
                                    },
                                    1024: {
                                      slidesPerView: 6,
                                    },
                                  }}
                                  className="homejson-slider"
                                >
                                  {iconImagesTwo.map((iconUrl: string, iconIndex: number) => (
                                    <SwiperSlide key={iconIndex}>
                                      <div
                                        className="img-option"
                                        onClick={() =>
                                          counthandleImageChange(iconUrl, index)
                                        }
                                      >
                                        <img
                                          src={iconUrl}
                                          alt="AI Icon"
                                          className="img-fluid"
                                        />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Icons Available</h6>
                                    <p className="text-muted small mb-3">
                                      Generate AI icons or upload your own to see them here
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* AI Icon Generator */}
                        <AIImageGenerator
                          generateAutoPrompt={generateAutoPromptIconTwo}
                          onSave={handleAIIconSaveTwo}
                          imageType="icon"
                          defaultWidth="128"
                          defaultHeight="128"
                          title="AI Icon"
                          autoGenerate={true}
                          template={template}
                        />

                        <div className="mb-3">
                          <label className="form-label">Upload Icon</label>
                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            className="form-control"
                            name="image"
                            onChange={updateImageSectionTwo}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">
                            Text<small>(max 250 char)</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="text"
                            value={card.text}
                            onChange={(e) => counthandleChange(e, index)}
                            maxLength={250}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Count</label>
                          <input
                            type="text"
                            className="form-control"
                            name="count"
                            value={card.count}
                            onChange={(e) => counthandleChange(e, index)}
                            maxLength={1200}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="add-section">
                <div className="row">
                  <div
                    onClick={() => {
                      countAddCollection();
                    }}
                    className="col text-center"
                  >
                    Add Card<i className="fas fa-plus-square ms-2"></i>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn primary-btn"
                  onClick={() => {
                    saveJsonData();
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
        {showCropModal ? (
          <>
            <div
              className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
              id="crop-modal"
              tabIndex={-1}
              aria-labelledby="crop-modal"
              aria-hidden="true"
              style={{ display: 'block' }}
            >
              <ImageCropper
                src={selectedCropImage}
                height={cropImageHeight}
                width={cropImageWidth}
                handleCrop={handleCroppedImage}
                close={() => {
                  setShowCropModal(false);
                }}
              />
            </div>
          </>
        ) : null}
        {showCropModalTwo ? (
          <>
            <div
              className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
              id="crop-modal"
              tabIndex={-1}
              aria-labelledby="crop-modal"
              aria-hidden="true"
              style={{ display: 'block' }}
            >
              <ImageCropper
                src={selectedCropImage}
                height={cropImageHeight}
                width={cropImageWidth}
                handleCrop={handleCroppedImageTwo}
                close={() => {
                  setShowCropModalTwo(false);
                }}
              />
            </div>
          </>
        ) : null}
      </>
    </>
  );
};

export default ServiceEditModal;
